// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_cs-b";
export var colorBlue = "_cs-8";
export var colorDot = "_cs-0";
export var colorDotLarge = "_cs-2";
export var colorDotSmall = "_cs-1";
export var colorGreen = "_cs-7";
export var colorGrey = "_cs-3";
export var colorOrange = "_cs-5";
export var colorPink = "_cs-a";
export var colorPurple = "_cs-9";
export var colorRed = "_cs-4";
export var colorYellow = "_cs-6";